import React from 'react';
import { string, shape } from 'prop-types';
import classNames from 'classnames';
import StyledLabel from '../../styled-label';
import Image from '../../image';
import PromotionsHighlights from '../../promotions/promotions-highlights';
import TagLabel from '../../promotions/label';

const namespace = 'ui-vip-header-proposal';
const DEFAULT_HEADER = {};

const HeaderProposal = ({ header = DEFAULT_HEADER }) => {
  const { tag_action, title, image, financing_percentage } = header;

  return (
    <div className={classNames(`${namespace}__container`)}>
      <div className={classNames(`${namespace}__wrapper-promotion`)}>
        <div className={classNames(`${namespace}__promotion-hightlights`)}>
          {tag_action && <PromotionsHighlights {...header} />}
          {financing_percentage && <TagLabel {...financing_percentage?.label} />}
        </div>
        <StyledLabel
          as="h2"
          text={title.text}
          color={title.color}
          font_size={title.font_size}
          font_family={title.font_family}
        />
      </div>
      {image ? (
        <Image
          data-testid={image.id}
          key={image.id}
          id={image.id}
          src={image.url.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
        />
      ) : null}
    </div>
  );
};

HeaderProposal.propTypes = {
  header: shape({
    title: shape({
      text: string,
      color: string,
      font_size: string,
      font_family: string,
    }),
    image: shape({
      alt: string,
      id: string,
      src: string,
      src2x: string,
    }),
    tag_action: shape({}),
    financing_percentage: shape({}),
  }),
};

export default HeaderProposal;
